import { useHasAccess } from '@energy-stacks/user-access';
import { CsmsFeature } from './csmsFeature';
import { csmsFeatureAccess } from './csmsFeatureAccess';

export const useCsmsFeatureGuard = (feature: CsmsFeature) => {
  return useHasAccess(csmsFeatureAccess, feature);
};
